import { render } from "./GerenciamentoImagem.vue?vue&type=template&id=aac3e7de&scoped=true"
import script from "./GerenciamentoImagem.vue?vue&type=script&lang=js"
export * from "./GerenciamentoImagem.vue?vue&type=script&lang=js"

import "./GerenciamentoImagem.vue?vue&type=style&index=0&id=aac3e7de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac3e7de"]])

export default __exports__